// 부가세 나누기 한 곳 — 견적·계약·변경공사가 같이 쓴다 · 한쪽만 반올림하고 나머지는 빼거나 더해 `supply + vat = total` 이 항등식이다.

import { checked, checkedMoney } from "./checked";

// 만분율 밑 — 계약 `BP_SCALE` 과 같은 자.
const SCALE = 10_000;

/** 부가가치세율 10%. 바뀐 적이 없지만 숫자를 코드에 흩뿌리지 않는다. */
export const VAT_RATE_BP = 1_000;

export const VAT_MODES = ["INCL", "EXCL"] as const;
// 판매 단가에 부가세가 들어 있는가(INCL) 빠져 있는가(EXCL).
export type VatMode = (typeof VAT_MODES)[number];

export const DEFAULT_VAT_MODE: VatMode = "INCL";

export interface VatSplit {
  total_amount: number;
  supply_amount: number;
  vat_amount: number;
}

// 총액 → 공급가 반올림 한 번 · 나누기 전에 곱을 재야 2^53 을 넘긴 곱이 조용히 1원 어긋나지 않는다.
const supplyFromTotal = (total: number): number =>
  Math.round(checked(total * SCALE, "공급가") / (SCALE + VAT_RATE_BP));

// 공급가 → 세액 반올림 한 번.
const vatFromSupply = (supply: number): number =>
  Math.round(checked(supply * VAT_RATE_BP, "부가세") / SCALE);

// 고객이 낼 돈(총액)을 알 때 — 공급가를 반올림으로 내고 세액은 뺀다.
export const amountsFromTotal = (total: number): VatSplit => {
  checkedMoney(total, "계약금액");
  const supply_amount = supplyFromTotal(total);
  return { total_amount: total, supply_amount, vat_amount: total - supply_amount };
};

// 공급가를 알 때(부가세 별도 견적) — 세액을 반올림으로 내고 총액은 더한다.
export const amountsFromSupply = (supply: number): VatSplit => {
  checkedMoney(supply, "공급가액");
  const vat_amount = vatFromSupply(supply);
  return {
    total_amount: checked(supply + vat_amount, "계약금액"),
    supply_amount: supply,
    vat_amount,
  };
};

// 머리에 굳힌 공급가·부가세가 총액과 맞으면 그대로, 없거나 어긋나면(옛 행) 총액에서 다시 나눈다.
export const storedSplitOf = (amounts: { total: number; supply_amount?: number | null; vat_amount?: number | null }): VatSplit => {
  const { total, supply_amount: supply, vat_amount: vat } = amounts;
  if (Number.isSafeInteger(supply) && Number.isSafeInteger(vat) && (supply as number) >= 0 && (vat as number) >= 0 && (supply as number) + (vat as number) === total) {
    return { total_amount: total, supply_amount: supply as number, vat_amount: vat as number };
  }
  return amountsFromTotal(total);
};
